import * as React from "react"
import { Text, Button, ButtonProps } from "@chakra-ui/react"
import { FiMail } from "react-icons/fi"

type AdditionProps = {
  onlyIcon?: boolean
}

export const MailButton: React.FC<ButtonProps & AdditionProps> = React.memo(
  ({ onlyIcon, ...props }) => {
    return (
      <Button
        background="gray"
        color="white"
        width="130px"
        marginTop="1rem"
        _active={{}}
        _hover={{}}
        _focus={{}}
        {...props}
      >
        <FiMail />
        {!onlyIcon && <Text marginLeft="0.5rem">Mail</Text>}
      </Button>
    )
  }
)
